import { Stack, Typography, StackProps, useTheme } from '@mui/material';
import { useIsMobile } from '../hooks';
import { publicAssets } from '../utils';

export type PoweredByProps = {
  id?: string;
  variant?: 'dark' | 'light';
  noBorder?: boolean;
  t: (key: string, options?: any) => string;
  sx?: StackProps['sx'];
};

export function PoweredBy({ variant = 'light', id, noBorder = false, t, sx }: PoweredByProps) {
  const isMobile = useIsMobile();
  const { palette } = useTheme();
  const isLight = variant === 'light';
  const height = isMobile ? 20 : 27;

  return (
    <Stack
      id={id}
      direction="row"
      spacing={1}
      justifyContent="center"
      width="100%"
      p={0.5}
      sx={{
        background: 'transparent',
        borderTop: noBorder ? 'none' : `1px solid ${palette.grey[200]}`,
        ...sx,
      }}
    >
      <Typography variant={isMobile ? 'body2' : 'body1'} color={isLight ? '#000' : '#fff'}>
        {t('labels.poweredBy')}
      </Typography>
      <img
        src={publicAssets('shared/yad_orange_logo.webp')}
        style={{
          height,
          width: 'auto',
          objectFit: 'contain',
        }}
        alt="yad logo"
      />
      <Typography variant={isMobile ? 'body2' : 'body1'} color={isLight ? '#000' : '#fff'}>
        &
      </Typography>
      <img
        src={publicAssets(`shared/treedis_logo_${isLight ? 'black' : 'white'}.webp`)}
        style={{
          height,
          width: 'auto',
          objectFit: 'contain',
        }}
        alt="treedis logo"
      />
    </Stack>
  );
}
